<template>
  <div>

    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Form -->
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm6 md8> 
            <span class="headline">{{ formTitle }}</span>
          </v-flex>
          <v-flex xs12 sm6 md4> 
            <span class="headline">Project Budget Information</span>
          </v-flex>
        </v-layout>              
      </v-card-title>

      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text class="pt-0">
          <v-container grid-list-md>
            <v-layout row wrap>
            <v-flex xs12 sm6 md7>

              <v-layout row wrap>
                <v-flex xs12 sm6 md6>              
                  <!-- return-object   -->
                  <v-autocomplete
                  v-model="formSchema.eco_code"
                  :items="ecoCodeList"
                  :loading="isLoading"          
                  item-text="eco_account_code"
                  item-value="ecoAccount_code"
                  label="Economic Code *"                         
                  :rules="[v => !!v || 'Economic code is required !']"
                  required
                   @change="onChangeEcoCode(formSchema.eco_code)"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                  label="Economic Code Name *"
                  item-text="eco_account_name"
                  item-value="eco_account_name"                
                  v-model="formSchema.account_name"
                  :items="ecoCodeList"
                  :rules="[v => !!v || 'Economic code name is required !']"
                  required 
                  readonly  
                  ></v-autocomplete>
                </v-flex>

              <v-flex xs12 sm6 md6>
                <v-autocomplete
                label="Measurement Unit *"
                item-text="name"
                item-value="id"
                v-model="formSchema.unit"
                :items="unitList"
                :rules="[v => !!v || 'Measurement unit is required !']"
                required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Quantity"
                v-model="formSchema.quantity"
                :rules="[number,lng6]"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                :label="`GoB Amount Hint:(${currentAC.gob_amount})`"
                v-model="formSchema.gob_amount"
                :rules="[decimal]"
                @input="totalAmount"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                :label="`IDA Amount Hint:(${currentAC.ida_amount})`"
                v-model="formSchema.ida_amount"
                :rules="[decimal]"
                @input="totalAmount"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Total Amount *"
                v-model="formSchema.total"
                :rules="[decimal]"
                required
                readonly
                ></v-text-field>
              </v-flex>

              <!-- <v-flex xs12 sm6 md6>
                <v-text-field
                label="Revision"
                v-model="formSchema.revision"
                :rules="[v => !!v || 'Revision is required !']"
                required
                ></v-text-field>
              </v-flex> -->

              <!-- <v-flex xs12 sm6 md6>
                <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'date', fieldValue:formSchema.date, label:'Start Date',required:1}"
                @setValue="setDateValue"
                ></DatePicker>
              </v-flex> -->

              <v-flex xs12 sm6 md6 >
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="formSchema.revision>0">
                <v-textarea label="Remarks" v-model="formSchema.remarks">></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 md12 >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
                    <v-icon>save</v-icon>
                    {{addUpdateBtn}}
                  </v-btn>
                  <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
                    <v-icon>refresh</v-icon>Reset
                  </v-btn>
                </v-card-actions>
              </v-flex>
            </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md5 style="border:1px solid #CCC; text-align:center;">  
            <!-- {{yearlyProBudgetInfo}}   -->              
              Document Name :  {{yearlyProBudgetInfo.document_name}}<br>
              Budgeting Year :  {{yearlyProBudgetInfo.budgeting_year}}<br>
              Start Date :  {{changeFormateDMY(yearlyProBudgetInfo.start_date)}}<br>
              End Date :  {{changeFormateDMY(yearlyProBudgetInfo.end_date)}}<br>
              File :  <!-- {{yearlyProBudgetInfo.upload_file_name}} -->
                <a
                target="_blank"
                v-if="yearlyProBudgetInfo.document_file_name"
                title="Download"
                :href="`${public_path}${yearlyProBudgetInfo.document_file_name}`"
                download
                >
                <v-icon v style="vertical-align:top; font-size:30px;">cloud_download</v-icon>
              </a>
              <br><br>

                <!-- <u style="color: green;font-weight: bold;">Account History</u><br>
                <div style="text-align:left;">
                (A) Project Budget Amount : {{TotalPjectAmount.total_amount | currency}} Tk.<br>
                (B) Yearly Project Budget Amount : {{TotalYearlyPjectAmount.total_amount | currency}} Tk.<br>
                (C)Total Expensee : {{totalExpenseAmount | currency}} Tk.<br>
                Available Amount(A-(B+C)) : 
                {{TotalPjectAmount.total_amount - (TotalYearlyPjectAmount.total_amount + totalExpenseAmount) | currency}} Tk.
                </div>-->
                
            </v-flex>
          </v-layout>
        </v-container>
        </v-card-text>      
      </v-form>

  </v-card>
  <!-- /Form -->
</div>
</template>


<script>
let commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";
import ServerPath from "../../../../server-path/server-path";

export default {
  props: ["formSchema"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    public_path: ServerPath.serverPath,
    is_activeVal: 1,

    isLoading: false,

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    yearlyProBudgetInfo:{
      log_in_project_id:'',
      budget_date:'',
      document_name:'',
      upload_file_name:'',
      is_active:''
    },
    unitList:[],
    ecoCodeList:[],

    TotalPjectAmount: {
      gob_amount:'',
      ida_amount:'',
      total_amount:'',
    },
    TotalYearlyPjectAmount: {
        gob_amount:'',
        ida_amount:'',
        total:'',
    },
    totalExpenseAmount:0,
    projectBudgetAmountbyEcoCode:[],
    currentAC: {
      gob_amount: "",
      ida_amount: "",
      total: ""
    }

  }),

  watch: {
    formSchema() {
      if(this.formSchema.id > 0){
        //alert(this.formSchema.id);
        this.onChangeEcoCode(this.formSchema.eco_code)
      }
    }
  },

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? 
      this.formSchema.revision > 0 ? "Revision Yearly Project Budget Details" : 
      "Edit Yearly Project Budget Details" : 
      "Add Yearly Project Budget Details";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? this.formSchema.revision > 0 ? "Revision" : "Update" : "Save";
    }

  },

  created() {
//sessionStorage.removeItem('revision')  

    let proId = sessionStorage.getItem("proId"); 
    commonService.getAllData("get-yearly-pro-budDet-dropdown-data/"+proId).then(res => {
        this.ecoCodeList = res.ecoCodeList;
        this.unitList = res.unitList;

        if(res.yearlyProBudgetInfo)
        {
          this.yearlyProBudgetInfo = res.yearlyProBudgetInfo;
        }
    });    
    
    commonService.getAllData("expense-amount").then(res => {
      this.TotalPjectAmount = res.TotalPjectAmount;
      this.TotalYearlyPjectAmount = res.TotalYearlyPjectAmount;
      this.totalExpenseAmount = res.totalExpenseAmount;
      this.projectBudgetAmountbyEcoCode = res.projectAmountbyEcoCode
    });
      
  },

  methods: {

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      formSchema.yProj_budget_id = sessionStorage.getItem("proId");

      //formSchema.date = this.changeFormateYMD(this.formSchema.date);   

      if (this.$refs.form.validate()) {

        if (formSchema.id > 0) {
          commonService.updateFormData(formSchema, "yearly-pro-budget-detail").then(res => {

            this.TotalPjectAmount = res.accountHistory.TotalPjectAmount;
            this.TotalYearlyPjectAmount = res.accountHistory.TotalYearlyPjectAmount;
            this.totalExpenseAmount = res.accountHistory.totalExpenseAmount;

            let actionData = {
              message: res.message,
              data: res.data,
              action: "edit",
              status: res.status
            };
            this.close(actionData);
          });
        } else {
          commonService.insertFormData(formSchema, "yearly-pro-budget-detail").then(res => {

            this.TotalPjectAmount = res.accountHistory.TotalPjectAmount;
            this.TotalYearlyPjectAmount = res.accountHistory.TotalYearlyPjectAmount;
            this.totalExpenseAmount = res.accountHistory.totalExpenseAmount;

            let actionData = {
              message: res.message,
              data: res.data,
              action: "add",
              status: res.status
            };
            this.close(actionData);
          });
        }
      }
    },

    totalAmount(){
      
      let formSchema = this.formSchema;
      let gob_amount = (formSchema.gob_amount>0) ? parseFloat(formSchema.gob_amount) : 0;
      let ida_amount = (formSchema.ida_amount>0) ? parseFloat(formSchema.ida_amount) : 0;
      var totalAmounts = gob_amount + ida_amount;

      var availableAmount = parseFloat(this.TotalPjectAmount.total_amount) - ( parseFloat(this.totalExpenseAmount));
      // parseFloat(this.TotalYearlyPjectAmount.total_amount) + ==> remove from uper line becose It's accept

      if(totalAmounts > availableAmount)
      {
        this.SnackbarVal.color = "error"; 
        this.SnackbarVal.message = "The total amount exceeds the amount available"
        this.SnackbarVal.snackbar = true;
        formSchema.total = '';
        return 0;
      }
      else if(formSchema.gob_amount > this.currentAC.gob_amount)
      {
        this.SnackbarVal.color = "error"; 
        this.SnackbarVal.message = "The GOB amount exceeds the amount is un-available"
        this.SnackbarVal.snackbar = true;
        formSchema.gob_amount = '';
        formSchema.total = '';
        this.valid = false
        return 0;
      } 
      else if(formSchema.ida_amount > this.currentAC.ida_amount)
      {
        this.SnackbarVal.color = "error"; 
        this.SnackbarVal.message = "The IDA amount exceeds the amount is un-available"
        this.SnackbarVal.snackbar = true;
        formSchema.total = '';
        formSchema.ida_amount = "";
        this.valid = false
        return 0;
      } 
      else 
      {
        formSchema.total = totalAmounts
      }      
    },

    onChangeEcoCode(eco_code)
    {   
      let selectedEcoCode = eco_code;
      
      let pro_val = {'pjectId': sessionStorage.getItem("proId"), 'eco_code':eco_code, 'tl':'3'}
      commonService.dataByMulParameters(pro_val,"check-eco-code-exist").then(res => {
        if(res.count > 0 && this.formSchema.id == 0)
        {
          this.formSchema.account_name = '';
          this.SnackbarVal.color = "error"; 
          this.SnackbarVal.message = "Economic code already exist"
          this.SnackbarVal.snackbar = true;
        }
      });

      let ecoCode = '';
      let finde =this.projectBudgetAmountbyEcoCode.filter(c => c.eco_code == selectedEcoCode)[0];
      this.currentAC.gob_amount = (this.formSchema.id > 0) ? 
        (parseFloat(finde.gob_amount) + parseFloat(this.formSchema.gob_amount)) || 0 : 
        finde.gob_amount;
      this.currentAC.ida_amount = (this.formSchema.id > 0) ? 
        (parseFloat(finde.ida_amount) + parseFloat(this.formSchema.ida_amount)) || 0 : 
        finde.ida_amount;
      this.currentAC.total = (this.formSchema.id > 0) ? (parseFloat(finde.total) + parseFloat(this.formSchema.total)) : finde.total;
      console.log( this.currentAC)
      if (eco_code) {
        ecoCode = this.ecoCodeList.filter(function(a) {
          return a.ecoAccount_code == eco_code;
        })[0].eco_account_name;
      }
      this.formSchema.account_name = ecoCode
    },
    
    resetForm(){
      this.formSchema.id = 0;      
    },

    close: function(data) {
      if (data.status == 1) {
        this.formSchema.id = 0;
        this.$refs.form.reset();
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>

<style scoped>
  .proTitle {
    color: #FFFFD8;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    background: #388e3c;
  }
</style>


// WEBPACK FOOTER //
// src/components/project_info/yearly_project_budget/yearly_pro_bud_details/insertForm.vue